import type { PresentationModule } from '../../../presentation/types';
import { mintTravel } from './content';
import { MintTravelScene } from './scenes/MintTravelScene';

export const mintTravelModule: PresentationModule = {
  id: 'mint-travel',
  label: 'MINT Travel & Events',
  priority: 'flagship',
  parent: 'mint',
  scenes: [
    { ...mintTravel, module: 'mint-travel', create: (resolved) => new MintTravelScene(resolved) },
  ],
};
